module.exports = __webpack_public_path__ + "1c58b54ed2e704812946584d01145726.MP3";